import { configureStore } from "@reduxjs/toolkit";
import gameReducer from "./slices/gameSlice";
import userReducer from "./slices/user";

export const store = configureStore({
  reducer: {
    games: gameReducer,
    user: userReducer,
  },
});

export default store;
export const dispatch = store.dispatch;
